function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M488.49,493.714V384h-62.694V91.429v-7.837V2.612H242.939v73.143H86.204V384H23.51v109.714H0v15.673h512v-15.673H488.49z  M410.122,185.469v83.592h-15.673v-62.694h-78.367v62.694h-20.898v-62.694h-78.367v62.694h-20.898v-62.694h-78.367v62.694h-15.673 v-83.592H410.122z M133.224,169.796v-47.02h47.02v47.02H133.224z M232.49,169.796v-47.02h47.02v47.02H232.49z M331.755,169.796 v-47.02h47.02v47.02H331.755z M378.775,222.041v47.02h-47.02v-47.02H378.775z M279.51,222.041v47.02h-47.02v-47.02H279.51z  M180.245,222.041v47.02h-47.02v-47.02H180.245z M410.122,284.735v15.673H101.878v-15.673H410.122z M258.612,18.286h151.51v57.469 h-151.51V18.286z M410.122,91.429v78.367h-15.673v-62.694h-78.367v62.694h-20.898v-62.694h-78.367v62.694h-20.898v-62.694h-78.367 v62.694h-15.673V91.429H410.122z M101.878,316.082h308.245v78.367h-15.673v-62.694h-78.367v62.694h-20.898v-62.694h-78.367v62.694 h-20.898v-62.694h-78.367v62.694h-15.673V316.082z M378.775,347.429v47.02h-47.02v-47.02H378.775z M279.51,347.429v47.02h-47.02 v-47.02H279.51z M180.245,347.429v47.02h-47.02v-47.02H180.245z M86.204,493.714h-47.02v-94.041h47.02V493.714z M227.265,493.714 v-47.02h20.898v23.51h15.673v-23.51h20.898v47.02H227.265z M300.408,493.714v-47.02h18.286V431.02H193.306v15.673h18.286v47.02 H101.878v-83.592h308.245v83.592H300.408z M472.816,493.714h-47.02v-94.041h47.02V493.714z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 276.898,
  y: 39.184,
  width: 20.898,
  height: 15.673
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 308.245,
  y: 39.184,
  width: 20.898,
  height: 15.673
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 339.592,
  y: 39.184,
  width: 20.898,
  height: 15.673
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 370.939,
  y: 39.184,
  width: 20.898,
  height: 15.673
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M117.551,478.041h57.469v-52.245h-57.469V478.041z M133.224,441.469h26.122v20.898h-26.122V441.469z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M336.98,478.041h57.469v-52.245H336.98V478.041z M352.653,441.469h26.122v20.898h-26.122V441.469z"
});

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

function SvgBuilding2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#808080"
    },
    points: "480.653,391.837 480.653,501.551 417.959,501.551 417.959,402.286 417.959,391.837 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A67C52"
    },
    d: "M292.571,438.857h-73.143v62.694H94.041v-99.265h31.347h62.694h36.571h62.694h36.571h62.694h31.347 v99.265H292.571V438.857z M386.612,470.204v-36.571h-41.796v36.571H386.612z M167.184,470.204v-36.571h-41.796v36.571H167.184z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C6239"
    },
    points: "417.959,391.837 417.959,402.286 386.612,402.286 386.612,339.592 323.918,339.592  323.918,402.286 287.347,402.286 287.347,339.592 224.653,339.592 224.653,402.286 188.082,402.286 188.082,339.592  125.388,339.592 125.388,402.286 94.041,402.286 94.041,391.837 94.041,308.245 417.959,308.245 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C69C6D"
    },
    points: "417.959,276.898 417.959,308.245 94.041,308.245 94.041,276.898 125.388,276.898  188.082,276.898 224.653,276.898 287.347,276.898 323.918,276.898 386.612,276.898 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A67C52"
    },
    points: "417.959,177.633 417.959,276.898 386.612,276.898 386.612,214.204 323.918,214.204  323.918,276.898 287.347,276.898 287.347,214.204 224.653,214.204 224.653,276.898 188.082,276.898 188.082,214.204  125.388,214.204 125.388,276.898 94.041,276.898 94.041,177.633 125.388,177.633 188.082,177.633 224.653,177.633 287.347,177.633  323.918,177.633 386.612,177.633 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C6239"
    },
    points: "417.959,83.592 417.959,177.633 386.612,177.633 386.612,114.939 323.918,114.939  323.918,177.633 287.347,177.633 287.347,114.939 224.653,114.939 224.653,177.633 188.082,177.633 188.082,114.939  125.388,114.939 125.388,177.633 94.041,177.633 94.041,83.592 250.775,83.592 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.775,
    y: 10.449,
    style: {
      fill: "#C69C6D"
    },
    width: 167.184,
    height: 73.143
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.816,
    y: 433.633,
    style: {
      fill: "#F2F2F2"
    },
    width: 41.796,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.918,
    y: 339.592,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.918,
    y: 214.204,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.918,
    y: 114.939,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.429,
    y: 438.857,
    style: {
      fill: "#F2F2F2"
    },
    width: 73.143,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.653,
    y: 339.592,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.653,
    y: 214.204,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.653,
    y: 114.939,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.388,
    y: 339.592,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.388,
    y: 214.204,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.388,
    y: 114.939,
    style: {
      fill: "#F2F2F2"
    },
    width: 62.694,
    height: 62.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.388,
    y: 433.633,
    style: {
      fill: "#F2F2F2"
    },
    width: 41.796,
    height: 36.571
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#808080"
    },
    points: "94.041,402.286 94.041,501.551 31.347,501.551 31.347,391.837 94.041,391.837 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2);
export default __webpack_public_path__ + "static/media/building2.159e8086.svg";
export { ForwardRef as ReactComponent };